// extracted by mini-css-extract-plugin
export default {"check-spacer":"25px","source-column":"170px","smallSpacer":"reportStyles_smallSpacer__QYoBM","largeSpacer":"reportStyles_largeSpacer__3jnrH"};